'use client';

import classnames from 'classnames';
import {
  IoCheckmarkCircle,
  IoCloseCircle,
  IoEllipseOutline,
} from 'react-icons/io5';

import type { BaseComponentProps } from '../../../base-component.types';
import { Icon } from '../../../icon';
import type { AnswerRateType } from '../MultipleChoiceQuestionAnswer.types';

import styles from './AnswerRate.module.scss';

type AnswerRateProps = BaseComponentProps & AnswerRateType;

function AnswerRate({
  style,
  className,
  correct,
  incorrect,
  skipped,
  testId,
}: AnswerRateProps) {
  return (
    <div
      style={style}
      className={classnames(styles['answer-wrapper'], className)}
      data-testid={testId}
    >
      <div className={classnames(styles['answer'], styles['answer--correct'])}>
        <Icon icon={<IoCheckmarkCircle />} role="img" aria-label="Aciertos" />
        <span className={styles['rate']}>{correct} %</span>
      </div>
      <div
        className={classnames(styles['answer'], styles['answer--incorrect'])}
      >
        <Icon icon={<IoCloseCircle />} role="img" aria-label="Fallos" />
        <span className={styles['rate']}>{incorrect} %</span>
      </div>
      <div className={classnames(styles['answer'], styles['answer--skipped'])}>
        <Icon icon={<IoEllipseOutline />} role="img" aria-label="En blanco" />
        <span className={styles['rate']}>{skipped} %</span>
      </div>
    </div>
  );
}

export { AnswerRate };
